// src/components/Admin/InstitutionCmp/InstitutionProfile/InstitutionProfile.js
import React from "react";
import { Table, Image } from "semantic-ui-react";
import { useTranslation } from "react-i18next";

export function InstitutionProfile({ data }) {
  const {
    avatar,
    institutionnam,
    created_at,
    firstname,
    lastname,
    email,
    phone,
    website,
    address,
    city,
    country,
    studentsnum,
    teachersnum,
  } = data;

  const { t } = useTranslation("institutions");
  const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString() : "–");

  return (
    <Table definition compact>
      <Table.Body>
        <Table.Row>
          <Table.Cell>
            <Image src={avatar} avatar size="mini" />
          </Table.Cell>
          <Table.Cell>{institutionnam}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{t("profile.joinDateLabel")}</Table.Cell>
          <Table.Cell>{fmt(created_at)}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{t("profile.contactLabel")}</Table.Cell>
          <Table.Cell>
            {firstname} {lastname}
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{t("profile.emailLabel")}</Table.Cell>
          <Table.Cell>{email}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{t("profile.phoneLabel")}</Table.Cell>
          <Table.Cell>{phone || "–"}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{t("profile.webLabel")}</Table.Cell>
          <Table.Cell>
            {website ? (
              <a href={website} target="_blank" rel="noopener noreferrer">
                {website}
              </a>
            ) : (
              "–"
            )}
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{t("profile.addressLabel")}</Table.Cell>
          <Table.Cell>
            {address}, {city}, {country}
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{t("profile.studentLicensesLabel")}</Table.Cell>
          <Table.Cell>{studentsnum}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{t("profile.teacherLicensesLabel")}</Table.Cell>
          <Table.Cell>{teachersnum}</Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
}
